module.exports = __webpack_public_path__ + "static/media/ic_上传.be6462bf.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ic_上传.svg
// module id = 368
// module chunks = 0